var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule"},[_c('iframe',{staticStyle:{"background-color":"white"},attrs:{"width":"100%","height":"100%","src":_vm.teacherStudentScheduleUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }